import React, { useCallback, useEffect, useRef, useState } from 'react';
import apiClient, { getCurrentUser } from '../services/api';
import './NotificationBell.css';

export default function NotificationBell({ onNavigate }) {
  const user = getCurrentUser();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const rootRef = useRef(null);

  const load = useCallback(async () => {
    if (user?.role !== 'guru') return;
    setLoading(true);
    try {
      const { data } = await apiClient.get('/notifications');
      setItems(data?.data || []);
      setUnreadCount(data?.unreadCount || 0);
    } catch {
      /* abaikan */
    } finally {
      setLoading(false);
    }
  }, [user?.role]);

  useEffect(() => {
    load();
    const interval = setInterval(load, 60000);
    return () => clearInterval(interval);
  }, [load]);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  if (user?.role !== 'guru') return null;

  const markRead = async (id) => {
    await apiClient.patch(`/notifications/${id}/read`);
    load();
  };

  const markAllRead = async () => {
    await apiClient.patch('/notifications/read-all');
    load();
  };

  const handleClick = (n) => {
    markRead(n._id);
    setOpen(false);
    if (n.link && onNavigate) {
      const tab = n.link.replace('/', '');
      onNavigate(tab);
    }
  };

  return (
    <div className="notification-bell" ref={rootRef}>
      <button
        type="button"
        className="bell-btn"
        onClick={() => setOpen((v) => !v)}
        aria-label="Notifikasi"
        aria-expanded={open}
        aria-haspopup="true"
      >
        <span aria-hidden="true">🔔</span>
        {unreadCount > 0 && <span className="bell-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>}
      </button>

      {open && (
        <div className="bell-dropdown" role="menu">
          <div className="bell-dropdown-header">
            <strong>Notifikasi</strong>
            {unreadCount > 0 && (
              <button type="button" className="bell-mark-all" onClick={markAllRead}>
                Tandai dibaca
              </button>
            )}
          </div>
          {loading ? (
            <p className="bell-empty">Memuat...</p>
          ) : items.length === 0 ? (
            <p className="bell-empty">Belum ada notifikasi</p>
          ) : (
            <ul className="bell-list">
              {items.map((n) => (
                <li key={n._id}>
                  <button
                    type="button"
                    className={`bell-item ${n.read ? 'read' : 'unread'}`}
                    onClick={() => handleClick(n)}
                    role="menuitem"
                  >
                    <span className="bell-item-title">{n.title}</span>
                    <span className="bell-item-msg">{n.message}</span>
                    <span className="bell-item-time">
                      {new Date(n.createdAt).toLocaleString('id-ID')}
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
